import React from "react";
import BaseModal from "./BaseModal";
import { useBatchDelete } from "show/list/hooks/apis";

interface Props {
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const BatchDeleteModal = (props: Props) => {
  const mutation = useBatchDelete(props.mainArea);

  const applyChanges = async () => mutation.mutateAsync(0); //Mock value

  return <BaseModal
    mainArea={props.mainArea}
    action="delete"
    onClose={props.onClose}
    title={RESX.Buttons.btnDeleteAll}
    hasSelectedValue={true}
    api={applyChanges}
  >
  </BaseModal>;
};

export default BatchDeleteModal;